const CONTAINER_ID = "toast-container";
const DEFAULT_TIMEOUT = 5000;

function getContainer() {
  if (typeof document === "undefined") {
    return null;
  }
  let container = document.getElementById(CONTAINER_ID);
  if (!container) {
    container = document.createElement("div");
    container.id = CONTAINER_ID;
    container.style.cssText = "position:fixed;top:70px;right:20px;z-index:2050;max-width:360px;";
    document.body.appendChild(container);
  }
  return container;
}

function notify(message, type = "danger", timeout = DEFAULT_TIMEOUT) {
  const container = getContainer();
  if (!container) {
    return;
  }
  const toast = document.createElement("div");
  toast.className = `alert alert-${type}`;
  toast.setAttribute("role", "alert");
  toast.style.cssText = "box-shadow:0 2px 8px rgba(0,0,0,0.15);margin-bottom:10px;";

  const closeButton = document.createElement("button");
  closeButton.type = "button";
  closeButton.className = "close";
  closeButton.setAttribute("data-bs-dismiss", "alert");

  const closeIcon = document.createElement("span");
  closeIcon.textContent = "×";
  closeButton.appendChild(closeIcon);

  const messageNode = document.createTextNode(message);
  toast.appendChild(closeButton);
  toast.appendChild(messageNode);
  container.appendChild(toast);

  const timeoutId = setTimeout(() => {
    toast.remove();
  }, timeout);

  closeButton.addEventListener("click", (event) => {
    event.preventDefault();
    clearTimeout(timeoutId);
    toast.remove();
  });
}

export default notify;
